import React, { useEffect, useState } from "react";
import { ScrollView } from "react-native";
import { Block } from "@block";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { spacing } from "@styles/spacing";
import { useDesktopMediaQuery } from "@media-query";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { StepProcessUniversal } from "app/shared/components/stepper-process/stepper-process";
import { RouteProp, StackActions, useNavigation, useRoute } from "@react-navigation/native";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ScreenNameType from "@navigation/nav-screens";
import { ACCOUNT } from "app/shared/services/services-model.type";
import GlobalModal, { createGlobalModal, globalModal } from "app/shared/components/modal/global-modal/global-modal";
import SourceTermDepositTopUp from "./source-term-deposit-top-up/source-term-deposite-top-up.web";
import FormTermDepositTopUp from "./form-term-deposit-top-up/form-term-deposit-top-up.web";
import { fetchTermDepositListTopUpRequest, fetchTermDepositTopUpCreateRequest, setTermTopUpReset } from "../reducer/actions";
import { Constant } from "app/shared/constant/constant";
import { getTermDepositTopUpSelector } from "../reducer/selectors";
import { DataTermDepositTopUp } from "../reducer/types";
import { RegisterOptions, useForm } from "react-hook-form";
import { InputTextCurrency } from "app/shared/components/form/input";
import StackParamsList from "app/navigation/nav-stack-params";
import { pushCleverTapEvent } from "app/shared/util/app-flyer";
import { getContactIdSelector } from "app/modules/account-management/reducer/selectors";

enum FormEnum {
  amount,
}

type ValidDataSchemeFormData = {
  [key in keyof typeof FormEnum]: Omit<RegisterOptions, "valueAsNumber" | "valueAsDate" | "setValueAs">;
};

export interface TermDepositTopUpData {
  amount: string;
}

type ProfileScreenRouteProp = RouteProp<StackParamsList, ScreenNameType.TERM_DEPOSIT_TOP_UP_CREATE>;

const TermDepositTopUp = () => {
  const dispatchStore = useDispatch();
  const { dispatch, navigate } = useNavigation();
  const isDesktop = useDesktopMediaQuery();
  const { t } = useTranslation();

  const { params } = useRoute<ProfileScreenRouteProp>();

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => {
        eventPushCleverTap(false);
        dispatch(StackActions.replace(ScreenNameType.HOME));
      },
    },
    {
      name: t("FUNC_TIET_KIEM"),
      onPressSubtitle: () => {
        eventPushCleverTap(false);
        dispatch(StackActions.replace(ScreenNameType.LIST_FUNCTION_TERM_DEPOSIT));
      },
    },
    {
      name: t("SAVING_NOP_THEM"),
      onPressSubtitle: () => {},
    },
  ];

  const routeProps = useRoute<ProfileScreenRouteProp>();
  const termTopUpStore = useSelector(getTermDepositTopUpSelector);
  const contactId = useSelector(getContactIdSelector);

  const [globalModalRef] = useState<React.RefObject<any>>(createGlobalModal());
  const [accountDebit, setAccountDebit] = useState<ACCOUNT>({});
  const [isValidAccount, setIsValidAccount] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  const { control, trigger, getValues } = useForm<TermDepositTopUpData>({
    defaultValues: {
      amount: "",
    },
    mode: "onChange",
  });

  const validateSchemeForm: ValidDataSchemeFormData = {
    amount: {
      required: {
        value: true,
        message: t("SAVING_LOI_CHUA_NHAP_SO_TIEN"),
      },
      validate: {
        amountMin: (value: string) => {
          if (value.length && Number(value) < 10000) {
            return t("COMMON_SO_TIEN_KHONG_DUOC_DUOI_10000D").toString();
          }
          return true;
        },
        amountMax: (value: string) => {
          if (accountDebit?.AVAILABLEBALANCE?.length && value.length && Number(value) > Number(accountDebit?.AVAILABLEBALANCE)) {
            return t("ACC_SO_DU_KHA_DUNG_NOT_ENOUGH").toString();
          }
          return true;
        },
      },
    },
  };

  const eventPushCleverTap = (status: boolean, response?: string) => {
    const { eventNameCT, paramsCT } = handlerParamsCleverTap(status, response);
    pushCleverTapEvent(eventNameCT, paramsCT);
  };

  const onCancel = () => {
    eventPushCleverTap(false);
    dispatch(StackActions.replace(ScreenNameType.LIST_FUNCTION_TERM_DEPOSIT));
  };

  // Submit Create
  const onSubmit = () => {
    setIsSubmit(true);
  };

  const onChangeAccountDebit = (account: ACCOUNT, isValid: boolean) => {
    setAccountDebit(account);
    setIsValidAccount(isValid);
    if (getValues("amount").length) trigger("amount");
  };

  const requestCreate = async (data: DataTermDepositTopUp) => {
    const triggerAmount = await trigger("amount");
    if (isValidAccount && triggerAmount && accountDebit?.ACCOUNTNO?.length) {
      const dataNew: DataTermDepositTopUp = {
        ...data,
        ACCOUNT_DEBIT: accountDebit,
        AMOUNT: getValues("amount"),
      };
      console.log("requestCreate: ", dataNew);
      dispatchStore(fetchTermDepositTopUpCreateRequest(dataNew));
    }
  };

  const closeModal = () => {
    globalModal.hide(globalModalRef);
  };

  const showModal = (content: JSX.Element) => {
    globalModal.show(content, globalModalRef);
  };

  const handlerParamsCleverTap = (status: boolean, response?: string) => {
    console.log("handlerParamsCleverTap");
    let term = termTopUpStore.dataCreate?.ACCOUNT_CREDIT?.FDTERM || "";
    if (term !== "") {
      term = term.replace("-", "");
    }
    let param = {};
    param = {
      ct_channel: "ib_rb",
      ct_cccd_ID: contactId,
      ct_cta: status ? "Tiếp tục" : "Hủy",
      ct_submit_deposit_product: termTopUpStore.dataCreate?.ACCOUNT_CREDIT?.PRODUCTCODE,
      ct_submit_deposit_term: term,
      ct_additional_submit_deposit_amount: termTopUpStore.dataCreate?.AMOUNT || "",
      ct_submit_deposit_branch: termTopUpStore.dataCreate?.ACCOUNT_CREDIT?.BRANCH_CODE || "",
    };
    if (response) {
      param = {
        ...param,
        ct_submit_deposit_status: response || "",
      };
    }

    return {
      eventNameCT: "ct_submit_deposit",
      paramsCT: param,
    };
  };

  useEffect(() => {
    console.log("Khởi tạo");
    if (routeProps?.params?.resetData === true) {
      dispatchStore(setTermTopUpReset());
      dispatchStore(fetchTermDepositListTopUpRequest());
    }
  }, [dispatchStore, routeProps?.params?.resetData]);

  useEffect(() => {
    if (isSubmit) setIsSubmit(false);
  }, [isSubmit]);

  useEffect(() => {
    if (termTopUpStore.isCreated) {
      eventPushCleverTap(true, "success");
      navigate(ScreenNameType.TERM_DEPOSIT_TOP_UP_CONFIRM);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [termTopUpStore.isCreated, navigate]);

  useEffect(() => {
    if (termTopUpStore.statusCreate === "pending") {
      eventPushCleverTap(true);
    }
    if (termTopUpStore.statusCreate === "error") {
      eventPushCleverTap(true, "failure");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [termTopUpStore.statusCreate]);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("SAVING_NOP_THEM")} subtitles={subtitlesArrays} />
        <Block pv={spacing.huge} ph={isDesktop ? spacing.galactic : spacing.huge}>
          <StepProcessUniversal currentSteps={0} />
          <SourceTermDepositTopUp
            typeArray={[Constant.ACCOUNTTYPE.ACCOUNT_PAYMENT]}
            isSubmit={isSubmit}
            account={accountDebit}
            onChangeAccount={onChangeAccountDebit}
            amountContent={
              <InputTextCurrency
                rules={validateSchemeForm.amount}
                name="amount"
                control={control}
                label={t("SAVING_SO_TIEN_NOP_THEM")}
                rightCurrency={t("COMMON_VND")}
              />
            }
          />
          <FormTermDepositTopUp
            accountCredit={params?.account}
            onSubmit={onSubmit}
            requestCreate={requestCreate}
            showModal={showModal}
            closeModal={closeModal}
            onCancel={onCancel}
          />
        </Block>
        <GlobalModal ref={globalModalRef} />
      </ScrollView>
    </Block>
  );
};

export default TermDepositTopUp;
